import { render, staticRenderFns } from "./Completed.vue?vue&type=template&id=d20fc398&scoped=true"
import script from "./Completed.vue?vue&type=script&lang=js"
export * from "./Completed.vue?vue&type=script&lang=js"
import style0 from "./Completed.vue?vue&type=style&index=0&id=d20fc398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20fc398",
  null
  
)

export default component.exports